import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
    <Reveal>
        <p
            className={`font-mono text-[11px] uppercase tracking-[0.3em] ${
                light ? "text-accent" : "text-accent-deep"
            }`}
        >
            {children}
        </p>
    </Reveal>
);

export const DemoTag = ({ children }) => (
    <span
        data-testid="demo-mode-tag"
        className="inline-flex items-center gap-1.5 border border-line-dark/40 px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-white/50"
    >
        <span className="h-1 w-1 rounded-full bg-accent" />
        {children}
    </span>
);
